(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[507],{

/***/ 84297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createLucideIcon; }
});

// UNUSED EXPORTS: toKebabCase

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/defaultAttributes.js
/**
 * @license lucide-react v0.314.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};


//# sourceMappingURL=defaultAttributes.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/createLucideIcon.js
/**
 * @license lucide-react v0.314.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */




const toKebabCase = (string) => string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase().trim();
const createLucideIcon = (iconName, iconNode) => {
  const Component = (0,react.forwardRef)(
    ({ color = "currentColor", size = 24, strokeWidth = 2, absoluteStrokeWidth, className = "", children, ...rest }, ref) => {
      return (0,react.createElement)(
        "svg",
        {
          ref,
          ...defaultAttributes,
          width: size,
          height: size,
          stroke: color,
          strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
          className: ["lucide", `lucide-${toKebabCase(iconName)}`, className].join(" "),
          ...rest
        },
        [
          ...iconNode.map(([tag, attrs]) => (0,react.createElement)(tag, attrs)),
          ...Array.isArray(children) ? children : [children]
        ]
      );
    }
  );
  Component.displayName = `${iconName}`;
  return Component;
};


//# sourceMappingURL=createLucideIcon.js.map


/***/ }),

/***/ 8971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChevronDown; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84297);
/**
 * @license lucide-react v0.314.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const ChevronDown = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);


//# sourceMappingURL=chevron-down.js.map


/***/ }),

/***/ 87011:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-of-service",
      function () {
        return __webpack_require__(59726);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FivaLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _FivaNavLayout_FivaNavLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51146);
/* harmony import */ var _components_Footer_FivaFooter_FivaFooter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31552);



function FivaLayout(param) {
    var children = param.children, blue = param.blue;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FivaNavLayout_FivaNavLayout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Footer_FivaFooter_FivaFooter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                blue: blue
            })
        ]
    });
}


/***/ }),

/***/ 59726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ terms_of_service; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./Layout/FivaLayout.tsx
var FivaLayout = __webpack_require__(32399);
// EXTERNAL MODULE: ./components/HeadComponent/HeadComponent.tsx
var HeadComponent = __webpack_require__(65722);
;// CONCATENATED MODULE: ./components/ServiceTerms/ServiceTerms.tsx

var ServiceTerms = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            padding: "1% 10%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                style: {
                    marginBottom: "0.5em"
                },
                children: "T\xe9rminos de Servicio de Fiva"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "\xdaltima actualizaci\xf3n: 13 de julio del 2023"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                style: {
                    padding: "1% 0%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Los presentes t\xe9rminos de servicio establecen los derechos y responsabilidades tanto del proveedor de la plataforma como de los usuarios que la utilizan. Antes de acceder y utilizar nuestra plataforma, te pedimos que leas detenidamente estos t\xe9rminos para comprender plenamente c\xf3mo funcionan nuestros servicios y c\xf3mo se aplican a tu interacci\xf3n con la plataforma."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Nuestra plataforma web tiene como objetivo principal ayudarte a mejorar la eficiencia de tu suministro el\xe9ctrico y reducir tus gastos en energ\xeda. Mediante un an\xe1lisis detallado de tu factura de luz, extraemos informaci\xf3n personal y de suministro el\xe9ctrico para ofrecerte las mejores opciones de tarifas disponibles en el mercado. Si decides seleccionar una tarifa, te guiaremos a trav\xe9s del proceso de recopilaci\xf3n de datos adicionales y firma necesarios para generar los contratos de la comercializadora seleccionada."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Es importante destacar que, al utilizar nuestra plataforma, aceptas cumplir con estos t\xe9rminos de servicio, as\xed como con cualquier pol\xedtica adicional que pueda aplicarse. Si no est\xe1s de acuerdo con alguno de estos t\xe9rminos, te pedimos que no utilices nuestra plataforma."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Nuestro compromiso es brindarte un servicio de calidad y garantizar la privacidad y seguridad de tus datos personales. Te invitamos a revisar nuestra",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "politica-de-privacidad.html",
                                children: "pol\xedtica de privacidad"
                            }),
                            " para obtener m\xe1s detalles sobre c\xf3mo manejamos la informaci\xf3n que nos proporcionas."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Te recomendamos que consultes regularmente los t\xe9rminos de servicio, ya que podr\xedan actualizarse peri\xf3dicamente para reflejar cambios en nuestras operaciones o en las leyes y regulaciones aplicables. Cualquier modificaci\xf3n de estos t\xe9rminos se te notificar\xe1 de acuerdo con los procedimientos establecidos."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Gracias por elegir nuestra plataforma web. Esperamos que encuentres en ella una herramienta \xfatil para optimizar tus gastos de energ\xeda y mejorar tu experiencia en el suministro el\xe9ctrico. Si tienes alguna pregunta o inquietud, no dudes en contactarnos a trav\xe9s de los canales de soporte proporcionados."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\xa1Bienvenido(a) a nuestra plataforma y disfruta de los beneficios que podemos ofrecerte!"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                style: {
                    padding: "1% 0%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        style: {
                            marginBottom: "0.5em"
                        },
                        children: "Interpretaci\xf3n y Definiciones"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Plataforma web"
                                    }),
                                    ": se refiere a la plataforma FIVA, que incluye el sitio web y todos los servicios relacionados proporcionados por FIVA E&S SOLUTIONS, SL, a trav\xe9s de los cuales los usuarios pueden subir sus facturas de luz, acceder a an\xe1lisis y recomendaciones de tarifas, y seleccionar una tarifa que se ajuste a sus necesidades."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Proveedor"
                                    }),
                                    ": se refiere a FIVA E&S SOLUTIONS, SL, la empresa propietaria y operadora de la plataforma web FIVA."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Usuario"
                                    }),
                                    ": se refiere a cualquier persona o entidad que accede y utiliza la plataforma web FIVA, incluyendo a los clientes que suben sus facturas de luz, revisan las recomendaciones de tarifas y eligen una tarifa para su suministro el\xe9ctrico."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Factura de luz"
                                    }),
                                    ": se refiere al documento emitido por la compa\xf1\xeda de suministro el\xe9ctrico que detalla el consumo de energ\xeda, los cargos aplicados, los datos personales del cliente y otra informaci\xf3n relevante relacionada con el suministro el\xe9ctrico."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Datos personales"
                                    }),
                                    ": se refiere a toda la informaci\xf3n que identifica o se puede utilizar para identificar a un individuo, incluyendo, entre otros, el nombre, la direcci\xf3n, el n\xfamero de tel\xe9fono, la direcci\xf3n de correo electr\xf3nico y la firma del usuario. La firma del usuario es recopilada y utilizada para completar los contratos de la comercializadora seleccionada a trav\xe9s de la plataforma web FIVA operada por FIVA E&S SOLUTIONS, SL."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Tarifas"
                                    }),
                                    ": se refiere a las opciones de precios y condiciones ofrecidas por las comercializadoras de energ\xeda para el suministro el\xe9ctrico, que se muestran al usuario en la plataforma web FIVA con el objetivo de que este elija una opci\xf3n para optimizar su factura de luz."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Comercializadora"
                                    }),
                                    ": se refiere a la empresa o entidad que se dedica a la venta y comercializaci\xf3n de energ\xeda el\xe9ctrica. Una vez que el usuario selecciona una tarifa en la plataforma web FIVA, FIVA E&S SOLUTIONS, SL utiliza los datos proporcionados por el usuario, incluida su firma, para tramitar el contrato con la comercializadora seleccionada en nombre del usuario."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                style: {
                    padding: "1% 0%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        style: {
                            marginBottom: "0.5em"
                        },
                        children: "Aceptaci\xf3n de los T\xe9rminos"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Al acceder o utilizar la plataforma web FIVA, aceptas cumplir y estar sujeto a estos t\xe9rminos de servicio, as\xed como a cualquier pol\xedtica adicional que pueda aplicarse. Esta aceptaci\xf3n se considera v\xe1lida y vinculante tanto para los usuarios individuales como para las entidades comerciales."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Uso adecuado de la plataforma:"
                                    }),
                                    " Te comprometes a utilizar la plataforma web FIVA \xfanicamente con fines legales y de acuerdo con estos t\xe9rminos de servicio. No debes utilizar la plataforma de manera que infrinja los derechos de terceros o viole cualquier ley, normativa o regulaci\xf3n aplicable."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Acceso y cuentas de usuario:"
                                    }),
                                    " Para acceder a ciertas funciones o servicios de la plataforma, es posible que debas crear una cuenta de usuario. Al hacerlo, te comprometes a proporcionar informaci\xf3n precisa, actualizada y completa, y a mantener la confidencialidad de tus credenciales de inicio de sesi\xf3n. Eres responsable de todas las actividades que ocurran bajo tu cuenta."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Datos personales y privacidad:"
                                    }),
                                    " Reconoces y aceptas que FIVA E&S SOLUTIONS, SL recopilar\xe1, utilizar\xe1 y proteger\xe1 tus datos personales de acuerdo con su pol\xedtica de privacidad. Al utilizar la plataforma, otorgas tu consentimiento para el uso de tus datos personales conforme a dicha pol\xedtica."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Propiedad intelectual:"
                                    }),
                                    " Reconoces y aceptas que FIVA E&S SOLUTIONS, SL es propietaria de todos los derechos de propiedad intelectual asociados a la plataforma web FIVA, incluyendo software, dise\xf1os, logotipos y otros contenidos. No se te concede ning\xfan derecho o licencia sobre estos elementos, excepto en la medida necesaria para utilizar la plataforma de acuerdo con estos t\xe9rminos de servicio."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Responsabilidades del usuario:"
                                    }),
                                    " Asumes toda la responsabilidad por el uso de la plataforma web FIVA y garantizas que la informaci\xf3n que proporcionas es precisa y actualizada. Te comprometes a utilizar la plataforma de acuerdo con estos t\xe9rminos de servicio, las leyes y regulaciones aplicables, y a respetar los derechos de propiedad intelectual de FIVA E&S SOLUTIONS, SL."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Limitaciones de responsabilidad:"
                                    }),
                                    " Reconoces y aceptas que el uso de la plataforma es bajo tu propio riesgo. FIVA E&S SOLUTIONS, SL no ser\xe1 responsable de cualquier da\xf1o directo, indirecto, incidental, especial, consecuente o punitivo derivado del uso o la incapacidad de utilizar la plataforma, incluso si se ha advertido sobre la posibilidad de dichos da\xf1os."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Modificaciones de los t\xe9rminos:"
                                    }),
                                    " FIVA E&S SOLUTIONS, SL se reserva el derecho de modificar estos t\xe9rminos de servicio en cualquier momento. Las modificaciones entrar\xe1n en vigor al ser publicadas en la plataforma web FIVA. Te recomendamos revisar peri\xf3dicamente los t\xe9rminos para estar al tanto de las actualizaciones."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                style: {
                    padding: "1% 0%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        style: {
                            marginBottom: "0.5em"
                        },
                        children: "Descripci\xf3n del Servicio"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "La plataforma web FIVA proporcionada por FIVA E&S SOLUTIONS, SL ofrece a los usuarios la oportunidad de optimizar sus facturas de luz y mejorar su experiencia en el suministro el\xe9ctrico. A trav\xe9s de nuestra plataforma, brindamos servicios de an\xe1lisis de facturas, recomendaciones de tarifas y asistencia en el proceso de contrataci\xf3n con comercializadoras de energ\xeda."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "El servicio se inicia con la opci\xf3n de carga de la factura de luz por parte del usuario. Nuestra plataforma utiliza tecnolog\xeda avanzada para analizar la factura y extraer los datos personales y de suministro el\xe9ctrico relevantes. Esto nos permite generar recomendaciones personalizadas de tarifas que se ajusten a las necesidades y preferencias del usuario."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Una vez que el usuario revisa las opciones de tarifas recomendadas, puede seleccionar la que mejor se adapte a sus requisitos. En ese momento, la plataforma solicitar\xe1 al usuario datos adicionales necesarios para completar el proceso de contrataci\xf3n, como informaci\xf3n de contacto, datos bancarios y firma digital."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Con la informaci\xf3n proporcionada por el usuario y su firma digital, FIVA E&S SOLUTIONS, SL se encarga de tramitar el contrato con la comercializadora seleccionada en nombre del usuario. Esto simplifica y agiliza el proceso de contrataci\xf3n, evitando al usuario la necesidad de lidiar directamente con la comercializadora."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Es importante tener en cuenta que FIVA E&S SOLUTIONS, SL act\xfaa como intermediario en el proceso de contrataci\xf3n y no asume responsabilidad por las acciones o servicios proporcionados por la comercializadora. Cualquier problema o consulta relacionada con el suministro el\xe9ctrico o el contrato debe ser dirigida directamente a la comercializadora correspondiente."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "La plataforma FIVA se esfuerza por brindar un servicio eficiente y confiable, utilizando tecnolog\xeda segura para proteger la privacidad y los datos personales de los usuarios. Sin embargo, es importante tener en cuenta que el an\xe1lisis de las facturas y las recomendaciones de tarifas son estimaciones basadas en la informaci\xf3n proporcionada por el usuario, y los resultados pueden variar seg\xfan las pol\xedticas y condiciones de las comercializadoras."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Estamos comprometidos a mejorar continuamente nuestra plataforma y ampliar los servicios ofrecidos para brindar a los usuarios una experiencia satisfactoria y resultados \xf3ptimos en su factura de luz."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Si tienes alguna pregunta o necesitas m\xe1s informaci\xf3n sobre nuestro servicio, no dudes en contactarnos. Estaremos encantados de ayudarte, puedes escribirnos a ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "contacto@fiva.es",
                                children: "contacto@fiva.es"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                style: {
                    padding: "1% 0%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        style: {
                            marginBottom: "0.5em"
                        },
                        children: "Propiedad Intelectual"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "FIVA E&S SOLUTIONS, SL"
                            }),
                            " es el titular de todos los derechos de propiedad intelectual asociados a la plataforma web FIVA y sus componentes. Esto incluye, pero no se limita a, software, dise\xf1o, logotipos, gr\xe1ficos, im\xe1genes, textos y cualquier otro contenido presente en la plataforma."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Al utilizar la plataforma web FIVA, reconoces y aceptas que estos derechos de propiedad intelectual est\xe1n protegidos por las leyes de propiedad intelectual aplicables. Queda estrictamente prohibido copiar, modificar, distribuir, transmitir, mostrar, reproducir, publicar, conceder licencias, crear trabajos derivados o utilizar de cualquier otra manera los elementos protegidos sin el consentimiento expreso y por escrito de FIVA E&S SOLUTIONS, SL."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Adem\xe1s, reconoces y aceptas que cualquier contenido generado por los usuarios y compartido en la plataforma web FIVA sigue siendo propiedad de los respectivos usuarios. Sin embargo, al utilizar la plataforma, otorgas a FIVA E&S SOLUTIONS, SL una licencia no exclusiva, perpetua, irrevocable, libre de regal\xedas y sublicenciable para utilizar, reproducir, modificar, adaptar, publicar, traducir, distribuir y mostrar dicho contenido con fines relacionados con la prestaci\xf3n de los servicios de la plataforma."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Cualquier uso no autorizado de los derechos de propiedad intelectual de FIVA E&S SOLUTIONS, SL puede dar lugar a acciones legales y reclamaciones por da\xf1os y perjuicios."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Si tienes alguna pregunta sobre los derechos de propiedad intelectual o necesitas obtener permiso para utilizar alg\xfan contenido espec\xedfico de la plataforma web FIVA, te invitamos a ponerte en contacto con nosotros para solicitar la correspondiente autorizaci\xf3n."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Recuerda que el respeto a la propiedad intelectual es fundamental para mantener un ambiente adecuado en la plataforma y proteger los derechos de todos los involucrados."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                style: {
                    padding: "1% 0%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        style: {
                            marginBottom: "0.5em"
                        },
                        children: "Privacidad y Protecci\xf3n de Datos"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Recopilaci\xf3n de datos:"
                                    }),
                                    " Al utilizar la plataforma web FIVA, es posible que se te solicite proporcionar los siguientes campos necesarios para cumplir con la ley de protecci\xf3n de datos:",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                style: {
                                                    marginBottom: "0.5em"
                                                },
                                                children: "Nombre completo: Para identificarte de manera adecuada y personalizar la experiencia en la plataforma."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                style: {
                                                    marginBottom: "0.5em"
                                                },
                                                children: "Direcci\xf3n: Para fines de contacto y facilitar el proceso de contrataci\xf3n con la comercializadora seleccionada."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                style: {
                                                    marginBottom: "0.5em"
                                                },
                                                children: "N\xfamero de tel\xe9fono: Para comunicarnos contigo en relaci\xf3n con tu cuenta y servicios relacionados."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                style: {
                                                    marginBottom: "0.5em"
                                                },
                                                children: "Direcci\xf3n de correo electr\xf3nico: Para enviar informaci\xf3n relevante sobre tu cuenta y servicios de la plataforma."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                style: {
                                                    marginBottom: "0.5em"
                                                },
                                                children: "Datos bancarios: Si es necesario para el proceso de contrataci\xf3n, podr\xedamos solicitar informaci\xf3n bancaria segura para realizar transacciones."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Uso de datos:"
                                    }),
                                    " Los datos personales recopilados se utilizan para los siguientes fines:",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                style: {
                                                    marginBottom: "0.5em"
                                                },
                                                children: "Realizar el an\xe1lisis de tu factura de luz y generar recomendaciones de tarifas adecuadas a tu perfil de consumo."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                style: {
                                                    marginBottom: "0.5em"
                                                },
                                                children: "Facilitar el proceso de contrataci\xf3n con la comercializadora seleccionada, utilizando la informaci\xf3n y la firma proporcionadas por ti."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                style: {
                                                    marginBottom: "0.5em"
                                                },
                                                children: "Comunicarnos contigo para brindarte actualizaciones, informaci\xf3n relevante sobre tu cuenta y servicios relacionados con la plataforma FIVA."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                style: {
                                                    marginBottom: "0.5em"
                                                },
                                                children: "Mejorar nuestros servicios, realizar an\xe1lisis estad\xedsticos y desarrollar nuevas funcionalidades de la plataforma."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Protecci\xf3n de datos:"
                                    }),
                                    " Implementamos medidas t\xe9cnicas y organizativas adecuadas para garantizar la seguridad de tus datos personales y protegerlos contra acceso no autorizado, p\xe9rdida, alteraci\xf3n o divulgaci\xf3n indebida. Adem\xe1s, nos aseguramos de que cualquier tercero con el que compartamos tus datos tenga las medidas de seguridad adecuadas en vigor."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Compartir datos:"
                                    }),
                                    " En determinadas circunstancias, podemos compartir tus datos personales con terceros, como las comercializadoras de energ\xeda para el proceso de contrataci\xf3n. Sin embargo, solo compartimos la informaci\xf3n necesaria para cumplir con los fines establecidos y nos aseguramos de que dichos terceros tambi\xe9n cumplan con las leyes y regulaciones de protecci\xf3n de datos."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Retenci\xf3n de datos:"
                                    }),
                                    " Conservamos tus datos personales durante el tiempo necesario para cumplir con los fines para los que se recopilaron, as\xed como para cumplir con nuestras obligaciones legales y resolver cualquier disputa. Cuando ya no sean necesarios, eliminaremos o anonimizaremos tus datos de forma segura."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Tus derechos:"
                                    }),
                                    " Tienes derecho a acceder, corregir, actualizar o eliminar tus datos personales que tenemos en nuestra posesi\xf3n. Tambi\xe9n puedes oponerte al procesamiento de tus datos o solicitar la limitaci\xf3n de su uso. Si deseas ejercer alguno de estos derechos o tienes alguna pregunta sobre el manejo de tus datos, puedes contactarnos utilizando la informaci\xf3n de contacto proporcionada al final de estos t\xe9rminos."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Cookies y tecnolog\xedas similares:"
                                    }),
                                    " Utilizamos cookies y tecnolog\xedas similares para mejorar tu experiencia en la plataforma. Puedes ajustar tus preferencias de cookies a trav\xe9s de la configuraci\xf3n de tu navegador, pero ten en cuenta que esto puede afectar la funcionalidad de la plataforma."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Para obtener m\xe1s informaci\xf3n sobre c\xf3mo recopilamos, utilizamos y protegemos tus datos personales, as\xed como sobre tus derechos y opciones, te invitamos a consultar nuestra pol\xedtica de privacidad, que se encuentra disponible en la plataforma web FIVA."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                style: {
                    padding: "1% 0%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: "Responsabilidades del Usuario"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Al utilizar la plataforma web FIVA proporcionada por FIVA E&S SOLUTIONS, SL, como usuario, tienes ciertas responsabilidades y obligaciones. A continuaci\xf3n, se detallan las principales responsabilidades del usuario:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Exactitud de la informaci\xf3n:"
                                    }),
                                    " Te comprometes a proporcionar informaci\xf3n precisa, actualizada y completa al utilizar la plataforma."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Uso adecuado de la plataforma:"
                                    }),
                                    " Te comprometes a utilizar la plataforma web FIVA de acuerdo con estos t\xe9rminos de servicio y las leyes y regulaciones aplicables."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Confidencialidad de tus credenciales de inicio de sesi\xf3n:"
                                    }),
                                    " ",
                                    "Eres responsable de mantener la confidencialidad de tus credenciales de inicio de sesi\xf3n."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Uso de los servicios de la plataforma:"
                                    }),
                                    " Al utilizar la plataforma web FIVA, aceptas que eres el \xfanico responsable de todas las decisiones que tomes basadas en las recomendaciones de tarifas proporcionadas."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Cumplimiento de las leyes y regulaciones:"
                                    }),
                                    " Te comprometes a cumplir con todas las leyes, regulaciones y requisitos legales aplicables al utilizar la plataforma web FIVA."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Comunicaci\xf3n y colaboraci\xf3n adecuadas:"
                                    }),
                                    " En caso de tener alguna consulta, duda o problema relacionado con la plataforma, te comprometes a comunicarte de manera adecuada y respetuosa con FIVA E&S SOLUTIONS, SL."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Uso responsable de la plataforma:"
                                    }),
                                    " Te comprometes a utilizar la plataforma de manera responsable, evitando cualquier actividad que pueda causar da\xf1o o afectar la disponibilidad, integridad o seguridad de la plataforma."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Recuerda que el incumplimiento de estas responsabilidades puede resultar en la suspensi\xf3n o terminaci\xf3n de tu acceso a la plataforma web FIVA. Adem\xe1s, si tu conducta viola las leyes y regulaciones aplicables, FIVA E&S SOLUTIONS, SL se reserva el derecho de tomar las acciones legales correspondientes."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                style: {
                    padding: "1% 0%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        style: {
                            marginBottom: "0.5em"
                        },
                        children: "Proceso de Contrataci\xf3n"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Recopilaci\xf3n de datos adicionales:"
                                    }),
                                    " Para completar el proceso de contrataci\xf3n, se te solicitar\xe1 proporcionar informaci\xf3n adicional, como datos de contacto, detalles bancarios y cualquier otro dato necesario para la contrataci\xf3n del suministro el\xe9ctrico."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Firma del contrato:"
                                    }),
                                    " Como parte del proceso de contrataci\xf3n, se te pedir\xe1 que proporciones una firma digital o electr\xf3nica para validar y autorizar el contrato con la comercializadora seleccionada."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Tramitaci\xf3n del contrato:"
                                    }),
                                    " Una vez que hayas proporcionado los datos requeridos y firmado el contrato, FIVA E&S SOLUTIONS, SL se encargar\xe1 de tramitar el contrato en tu nombre con la comercializadora elegida."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Validaci\xf3n por parte de la comercializadora:"
                                    }),
                                    " ",
                                    "Despu\xe9s de que se haya tramitado el contrato, la comercializadora puede realizar una validaci\xf3n adicional para verificar la informaci\xf3n proporcionada y confirmar la contrataci\xf3n del suministro el\xe9ctrico."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Confirmaci\xf3n y activaci\xf3n del suministro:"
                                    }),
                                    " Una vez que la comercializadora haya validado y aceptado el contrato, recibir\xe1s una confirmaci\xf3n de la contrataci\xf3n y se proceder\xe1 a la activaci\xf3n del suministro el\xe9ctrico."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Es importante tener en cuenta que FIVA E&S SOLUTIONS, SL act\xfaa como intermediario en el proceso de contrataci\xf3n y no asume responsabilidad por los servicios o acciones de la comercializadora. Cualquier consulta, duda o reclamaci\xf3n relacionada con el suministro el\xe9ctrico debe dirigirse directamente a la comercializadora correspondiente."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Si tienes alguna pregunta o necesitas m\xe1s informaci\xf3n sobre el proceso de contrataci\xf3n a trav\xe9s de la plataforma web FIVA, no dudes en contactarnos. Estaremos encantados de ayudarte y brindarte la asistencia necesaria."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                style: {
                    padding: "1% 0%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        style: {
                            marginBottom: "0.5em"
                        },
                        children: "Limitaciones de Responsabilidad"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Al utilizar la plataforma web FIVA proporcionada por FIVA E&S SOLUTIONS, SL, es importante tener en cuenta las siguientes limitaciones de responsabilidad:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Uso bajo tu propio riesgo:"
                                    }),
                                    " Reconoces y aceptas que el uso de la plataforma FIVA se realiza bajo tu propio riesgo. La plataforma se proporciona tal cual y seg\xfan disponibilidad. FIVA E&S SOLUTIONS, SL no garantiza la disponibilidad, precisi\xf3n, integridad, confiabilidad o idoneidad de la plataforma para un prop\xf3sito particular. No asumimos responsabilidad por cualquier da\xf1o o perjuicio resultante del uso o la incapacidad de utilizar la plataforma."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Exactitud de la informaci\xf3n:"
                                    }),
                                    " Aunque nos esforzamos por ofrecer recomendaciones precisas y actualizadas sobre las tarifas de energ\xeda, debes tener en cuenta que los resultados pueden variar y dependen de la informaci\xf3n proporcionada por ti. No podemos garantizar la exactitud o veracidad de la informaci\xf3n contenida en la plataforma, incluyendo las tarifas y las condiciones ofrecidas por las comercializadoras de energ\xeda."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Responsabilidad de las comercializadoras:"
                                    }),
                                    " FIVA E&S SOLUTIONS, SL act\xfaa como intermediario en el proceso de contrataci\xf3n, facilitando la relaci\xf3n entre los usuarios y las comercializadoras de energ\xeda. No asumimos responsabilidad por los servicios, productos o acciones de las comercializadoras. Cualquier problema, disputa o reclamaci\xf3n relacionada con el suministro el\xe9ctrico debe ser dirigida directamente a la comercializadora correspondiente."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Limitaci\xf3n de da\xf1os:"
                                    }),
                                    " En la medida permitida por la ley aplicable, FIVA E&S SOLUTIONS, SL no ser\xe1 responsable por ning\xfan da\xf1o directo, indirecto, incidental, especial, consecuente o punitivo, incluyendo, entre otros, p\xe9rdida de datos, ingresos, ganancias o da\xf1os a la reputaci\xf3n, derivados del uso o la incapacidad de utilizar la plataforma."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Exoneraci\xf3n de responsabilidad:"
                                    }),
                                    " Aceptas exonerar y mantener indemne a FIVA E&S SOLUTIONS, SL y a sus directores, empleados y agentes de cualquier reclamaci\xf3n, demanda, acci\xf3n, p\xe9rdida, responsabilidad o gasto, incluyendo los honorarios razonables de abogados, que surjan o est\xe9n relacionados con tu uso de la plataforma FIVA o cualquier incumplimiento de estos t\xe9rminos de servicio."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Es importante tener en cuenta estas limitaciones de responsabilidad al utilizar la plataforma web FIVA. Si tienes alguna pregunta o inquietud relacionada con estas limitaciones, te recomendamos ponerte en contacto con nosotros para obtener m\xe1s informaci\xf3n."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Recuerda que estas limitaciones de responsabilidad no afectan tus derechos legales en virtud de las leyes aplicables, y en caso de que alguna disposici\xf3n de estos t\xe9rminos de servicio sea considerada inv\xe1lida o inaplicable, las dem\xe1s disposiciones seguir\xe1n siendo v\xe1lidas y aplicables en la m\xe1xima medida permitida por la ley."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                style: {
                    padding: "1% 0%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        style: {
                            marginBottom: "0.5em"
                        },
                        children: "Cancelaci\xf3n y T\xe9rmino de Servicio"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "En el caso de que desees cancelar tu uso de la plataforma web FIVA proporcionada por FIVA E&S SOLUTIONS, SL, o dar por terminados estos t\xe9rminos de servicio, a continuaci\xf3n, se describen los aspectos relevantes relacionados con la cancelaci\xf3n y el t\xe9rmino del servicio:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Cancelaci\xf3n por parte del usuario:"
                                    }),
                                    " Tienes el derecho de cancelar tu cuenta y dejar de utilizar la plataforma en cualquier momento. Para cancelar tu cuenta, puedes comunicarte con nosotros a trav\xe9s de los canales de contacto proporcionados en la plataforma. Ten en cuenta que la cancelaci\xf3n de tu cuenta puede resultar en la p\xe9rdida de acceso a ciertos servicios y funcionalidades de la plataforma."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Terminaci\xf3n por parte de FIVA E&S SOLUTIONS, SL:"
                                    }),
                                    " ",
                                    "Nos reservamos el derecho de dar por terminados estos t\xe9rminos de servicio y suspender o cancelar tu acceso a la plataforma FIVA en cualquier momento y por cualquier motivo, incluyendo, entre otros, el incumplimiento de estos t\xe9rminos o cualquier actividad que consideremos inapropiada, ilegal o perjudicial para la plataforma o para otros usuarios."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Efecto de la cancelaci\xf3n o terminaci\xf3n:"
                                    }),
                                    " En caso de cancelaci\xf3n o terminaci\xf3n, se te solicitar\xe1 dejar de utilizar la plataforma y cualquier contenido, informaci\xf3n o datos relacionados con tu cuenta. FIVA E&S SOLUTIONS, SL puede retener cierta informaci\xf3n relacionada con tu cuenta de acuerdo con nuestras pol\xedticas de retenci\xf3n de datos o seg\xfan lo exijan las leyes y regulaciones aplicables."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Consecuencias posteriores a la cancelaci\xf3n o terminaci\xf3n:"
                                    }),
                                    " ",
                                    "Despu\xe9s de la cancelaci\xf3n o terminaci\xf3n, no seremos responsables por la p\xe9rdida de acceso a la plataforma o a cualquier contenido, informaci\xf3n o datos relacionados. Te recomendamos tomar las medidas necesarias para respaldar y guardar cualquier informaci\xf3n importante antes de la cancelaci\xf3n o terminaci\xf3n de tu cuenta."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Es importante tener en cuenta que, independientemente de la cancelaci\xf3n o terminaci\xf3n, ciertas disposiciones de estos t\xe9rminos de servicio seguir\xe1n siendo aplicables, como las relacionadas con la propiedad intelectual, limitaciones de responsabilidad y protecci\xf3n de datos."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Si tienes alguna pregunta o necesitas m\xe1s informaci\xf3n sobre la cancelaci\xf3n o t\xe9rmino del servicio, te recomendamos ponerte en contacto con nosotros para obtener la asistencia necesaria."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Ten en cuenta que estos t\xe9rminos de servicio est\xe1n sujetos a cambios y actualizaciones peri\xf3dicas. Te recomendamos revisar regularmente los t\xe9rminos de servicio para estar al tanto de cualquier modificaci\xf3n."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                style: {
                    padding: "1% 0%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: "Modificaciones de los T\xe9rminos de Servicio"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "FIVA E&S SOLUTIONS, SL se reserva el derecho de realizar modificaciones o actualizaciones a estos t\xe9rminos de servicio en cualquier momento y a su entera discreci\xf3n. Cuando se realicen cambios significativos en los t\xe9rminos, se te notificar\xe1 mediante un aviso en la plataforma web FIVA o a trav\xe9s de otros medios de comunicaci\xf3n adecuados."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Es importante que revises regularmente los t\xe9rminos de servicio para estar al tanto de cualquier modificaci\xf3n. El uso continuado de la plataforma despu\xe9s de la publicaci\xf3n de los cambios constituir\xe1 tu aceptaci\xf3n de los t\xe9rminos modificados. Si no est\xe1s de acuerdo con los nuevos t\xe9rminos, debes dejar de utilizar la plataforma."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Adem\xe1s, ten en cuenta que ciertos aspectos de la plataforma pueden estar sujetos a t\xe9rminos y condiciones adicionales o pol\xedticas espec\xedficas. Estos t\xe9rminos adicionales se proporcionar\xe1n de manera clara y se considerar\xe1n parte integral de los t\xe9rminos de servicio."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "FIVA E&S SOLUTIONS, SL se esforzar\xe1 por proporcionar una notificaci\xf3n adecuada y suficiente de cualquier modificaci\xf3n de los t\xe9rminos de servicio. Sin embargo, es tu responsabilidad revisar regularmente los t\xe9rminos para estar al tanto de cualquier cambio."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Si tienes alguna pregunta o inquietud sobre las modificaciones de los t\xe9rminos de servicio, te recomendamos ponerte en contacto con nosotros para obtener m\xe1s informaci\xf3n y aclaraciones."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Recuerda que estos t\xe9rminos de servicio son vinculantes y establecen la relaci\xf3n entre t\xfa y FIVA E&S SOLUTIONS, SL en relaci\xf3n con el uso de la plataforma web FIVA."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                style: {
                    padding: "1% 0%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        style: {
                            marginBottom: "0.5em"
                        },
                        children: "Ley Aplicable y Jurisdicci\xf3n"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Estos t\xe9rminos de servicio y cualquier disputa o reclamaci\xf3n relacionada con el uso de la plataforma web FIVA se regir\xe1n e interpretar\xe1n de acuerdo con las leyes del pa\xeds o regi\xf3n correspondiente en el que opera FIVA E&S SOLUTIONS, SL."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Cualquier disputa o reclamaci\xf3n que surja de o en relaci\xf3n con estos t\xe9rminos de servicio, incluyendo cualquier cuesti\xf3n relativa a su existencia, validez, interpretaci\xf3n, ejecuci\xf3n o terminaci\xf3n, ser\xe1 sometida a la jurisdicci\xf3n exclusiva de los tribunales competentes en el pa\xeds o regi\xf3n correspondiente en el que opera FIVA E&S SOLUTIONS, SL."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "FIVA E&S SOLUTIONS, SL y t\xfa acuerdan someterse a la jurisdicci\xf3n exclusiva de dichos tribunales y renuncian a cualquier objeci\xf3n a la conveniencia o competencia de tales tribunales para resolver cualquier disputa o reclamaci\xf3n."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "En caso de que alguna disposici\xf3n de estos t\xe9rminos de servicio sea considerada inv\xe1lida o inaplicable por un tribunal competente, las dem\xe1s disposiciones seguir\xe1n siendo v\xe1lidas y aplicables en la m\xe1xima medida permitida por la ley."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Si tienes alguna pregunta o inquietud sobre la ley aplicable y la jurisdicci\xf3n relacionada con estos t\xe9rminos de servicio, te recomendamos ponerte en contacto con nosotros para obtener m\xe1s informaci\xf3n y asesoramiento legal espec\xedfico."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                style: {
                    padding: "1% 0%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        style: {
                            marginBottom: "0.5em"
                        },
                        children: "Disposiciones Generales"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Independencia de las partes:"
                                    }),
                                    " Estos t\xe9rminos de servicio no crean ninguna relaci\xf3n de agencia, asociaci\xf3n, sociedad, empleo u otro tipo de relaci\xf3n similar entre t\xfa y FIVA E&S SOLUTIONS, SL. Eres un usuario independiente de la plataforma web FIVA y no tienes autoridad para actuar en nombre de FIVA E&S SOLUTIONS, SL."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Cesi\xf3n:"
                                    }),
                                    " No puedes ceder, transferir ni sublicenciar tus derechos y obligaciones establecidos en estos t\xe9rminos de servicio sin el consentimiento previo y por escrito de FIVA E&S SOLUTIONS, SL. Sin embargo, FIVA E&S SOLUTIONS, SL puede ceder, transferir o delegar estos t\xe9rminos a terceros sin restricciones."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Acuerdo completo:"
                                    }),
                                    " Estos t\xe9rminos de servicio constituyen el acuerdo completo entre t\xfa y FIVA E&S SOLUTIONS, SL en relaci\xf3n con el uso de la plataforma web FIVA y reemplazan cualquier acuerdo o entendimiento previo, ya sea escrito o verbal, en relaci\xf3n con el mismo tema."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Renuncia:"
                                    }),
                                    " La falta de ejercicio por parte de FIVA E&S SOLUTIONS, SL de cualquier derecho o disposici\xf3n establecida en estos t\xe9rminos de servicio no se considerar\xe1 una renuncia a dicho derecho o disposici\xf3n. Cualquier renuncia debe ser espec\xedfica y por escrito para ser v\xe1lida."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Divisibilidad:"
                                    }),
                                    " Si alguna disposici\xf3n de estos t\xe9rminos de servicio se considera inv\xe1lida, ilegal o inaplicable por un tribunal competente, dicha disposici\xf3n se interpretar\xe1 en la m\xe1xima medida permitida por la ley para reflejar las intenciones originales de las partes, y las dem\xe1s disposiciones seguir\xe1n siendo v\xe1lidas y aplicables."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                style: {
                                    marginBottom: "0.5em"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Comunicaciones:"
                                    }),
                                    " Las comunicaciones entre t\xfa y FIVA E&S SOLUTIONS, SL relacionadas con la plataforma web FIVA se realizar\xe1n principalmente a trav\xe9s de los canales de comunicaci\xf3n proporcionados en la plataforma. Aceptas recibir comunicaciones electr\xf3nicas y reconoces que dichas comunicaciones satisfacen cualquier requisito legal de comunicaci\xf3n por escrito."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Si tienes alguna pregunta o necesitas m\xe1s informaci\xf3n sobre las disposiciones generales de estos t\xe9rminos de servicio, te recomendamos ponerte en contacto con nosotros. Estaremos encantados de brindarte aclaraciones adicionales."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ServiceTerms_ServiceTerms = (ServiceTerms);

;// CONCATENATED MODULE: ./pages/terms-of-service.tsx





var TermsOfService = function TermsOfService() {
    var headerProps = {
        title: "T\xe9rminos de servicio",
        keywords: 'T\xe9rminos de servicio, Plataforma web "FIVA", FIVA E&S SOLUTIONS, SL, Datos personales,    Propiedad intelectual, Privacidad, Protecci\xf3n de datos, Responsabilidades del usuario,    Proceso de contrataci\xf3n, Cancelaci\xf3n, Modificaciones de los t\xe9rminos, Ley aplicable, Jurisdicci\xf3n,    Disposiciones generales, Independencia, Cesi\xf3n, Acuerdo completo, Renuncia, Divisibilidad, Comunicaciones',
        content: "T\xe9rminos de Servicio de FIVA, informaci\xf3n sobre el uso de la plataforma."
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FivaLayout/* default */.Z, {
        blue: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadComponent/* default */.Z, (0,_object_spread/* default */.Z)({}, headerProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceTerms_ServiceTerms, {})
        ]
    });
};
/* harmony default export */ var terms_of_service = (TermsOfService);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4838,9453,1552,1146,9774,2888,179], function() { return __webpack_exec__(87011); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);